import React from 'react';
import './AboutUs.css';
function About(){
    return(
        
      <div className='about_container'>
            <div className='about_title'>About</div>
            <div className='about_descr'>LawLift provides women with information about their legal rights and resources for seeking legal assistance.</div>
            
        </div>
        );
    }
    export default About;